
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#ED1B2F","d":"M0 0h32v32H0z"}}),_c('path',{attrs:{"d":"M20.019 6.286a.12.12 0 01.116.09l4.433 18.049a.119.119 0 01-.116.146h-5.04a.12.12 0 01-.117-.09L14.86 6.432a.119.119 0 01.116-.146h5.042zM9.723 15.429h5.015c.077 0 .134.072.116.146l-2.176 8.906a.12.12 0 01-.116.09H7.548a.119.119 0 01-.116-.146l2.175-8.906a.12.12 0 01.116-.09z","fill":"#fff"}})])
          )
        }
      }
    